import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { IS_EMAIL_VIEW } from '../config/vars.js';

const headers = {
  o2: require('../components/headers/o2.js').default,
};

const Header = () => {
  const theme = useContext(ThemeContext);

  if (!IS_EMAIL_VIEW && theme && theme.name && headers[theme.name]) {
    const CustomHeader = headers[theme.name];
    return <CustomHeader />;
  }
  return null;
};

export default Header;
